"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminAdd = adminAdd;
exports.adminDel = adminDel;
exports.adminInfo = adminInfo;
exports.adminList = adminList;
exports.adminNameUpdateApi = adminNameUpdateApi;
exports.adminPwdUpdateApi = adminPwdUpdateApi;
exports.adminUpdate = adminUpdate;
exports.getMenu = getMenu;
exports.menuAdd = menuAdd;
exports.menuDelete = menuDelete;
exports.menuInfo = menuInfo;
exports.menuListApi = menuListApi;
exports.menuUpdate = menuUpdate;
exports.menuUpdateShowStatus = menuUpdateShowStatus;
exports.sensitiveListApi = sensitiveListApi;
exports.updateIsSmsApi = updateIsSmsApi;
exports.updateStatusApi = updateStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function getMenu() {
  return (0, _request.default)({
    url: '/admin/system/role/testMenu',
    method: 'GET'
  });
}
function adminDel(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/admin/delete',
    method: 'GET',
    params: data
  });
}
function adminInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/admin/info',
    method: 'GET',
    params: data
  });
}
function adminList(params) {
  return (0, _request.default)({
    url: '/admin/system/admin/list',
    method: 'GET',
    params: params
  });
}
function adminAdd(pram) {
  var data = {
    account: pram.account,
    level: pram.level,
    pwd: pram.pwd,
    realName: pram.realName,
    roles: pram.roles.join(','),
    status: pram.status,
    phone: pram.phone
  };
  return (0, _request.default)({
    url: '/admin/system/admin/save',
    method: 'POST',
    data: data
  });
}
function adminUpdate(pram) {
  var data = {
    account: pram.account,
    phone: pram.phone,
    pwd: pram.pwd,
    roles: pram.roles,
    realName: pram.realName,
    status: pram.status,
    id: pram.id,
    isDel: pram.isDel
  };
  return (0, _request.default)({
    url: '/admin/system/admin/update',
    method: 'POST',
    data: data
  });
}

/**
 * 修改状态
 * @param pram
 */
function updateStatusApi(params) {
  return (0, _request.default)({
    url: "/admin/system/admin/updateStatus",
    method: 'get',
    params: params
  });
}

/**
 * 修改后台管理员是否接收状态
 * @param pram
 */
function updateIsSmsApi(params) {
  return (0, _request.default)({
    url: "/admin/system/admin/update/isSms",
    method: 'get',
    params: params
  });
}

/**
 * 权限规则菜单列表
 * @param pram
 */
function menuListApi(params) {
  var data = {
    menuType: params.menuType,
    //菜单类型:M-目录，C-菜单，A-按钮
    name: params.name //菜单名称
  };
  return (0, _request.default)({
    url: "/admin/system/menu/list",
    method: 'get',
    params: data
  });
}

/**
 * 权限规则新增菜单
 * @param data
 */
function menuAdd(data) {
  var systemMenuRequest = data;
  return (0, _request.default)({
    url: "/admin/system/menu/add",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 权限规则删除菜单
 * @param data
 */
function menuDelete(id) {
  return (0, _request.default)({
    url: "/admin/system/menu/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 权限规则菜单详情
 * @param data
 */
function menuInfo(id) {
  return (0, _request.default)({
    url: "/admin/system/menu/info/".concat(id),
    method: 'get'
  });
}

/**
 * 权限规则菜单修改
 * @param data
 */
function menuUpdate(data) {
  var systemMenuRequest = data;
  return (0, _request.default)({
    url: "/admin/system/menu/update",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 权限规则修改菜单显示状态
 * @param data
 */
function menuUpdateShowStatus(params) {
  return (0, _request.default)({
    url: "/admin/system/menu/updateShowStatus",
    method: 'post',
    params: params
  });
}

//
/**
 * 权限规则菜单详情
 * @param data
 */
function sensitiveListApi(params) {
  return (0, _request.default)({
    url: "/admin/log/sensitive/list",
    method: 'get',
    params: params
  });
}
/**
 * 修改登录用户信息
 * @param data
 */
function adminNameUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/login/admin/update",
    method: 'post',
    data: data
  });
}
/**
 * 修改登录密码
 * @param data
 */
function adminPwdUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/login/update/password",
    method: 'post',
    data: data
  });
}